import { formatConditionForDisplay } from '../constants';

function Step3Review({ segmentData }) {
  const { name, condition_logic, conditions } = segmentData;

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 12, color: '#717679', marginBottom: 4 }}>Segment Name</div>
        <div style={{ fontWeight: 600 }}>{name}</div>
      </div>
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 12, color: '#717679', marginBottom: 4 }}>Type</div>
        <div style={{ fontSize: 12, color: '#717679' }}>
          This segment updates automatically based on your defined conditions.
        </div>
      </div>
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 12, color: '#717679', marginBottom: 4 }}>Segment Conditions</div>
        <div style={{ marginBottom: 4 }}>
          Customers will be included when they match {condition_logic === 'any' ? 'ANY' : 'ALL'} of the following:
        </div>
        <ul style={{ marginLeft: 20, marginBottom: 0 }}>
          {(conditions || []).map((c, i) => (
            <li key={i}>{formatConditionForDisplay(c)}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Step3Review;
